import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, } from '@mui/material'

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
    status: 'pending' | 'resolved';
}

export default function AddReply({ open, onClose, setOpen, status }: ModalProps) {
    return (
        <Modal
            className="modal addReply_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Reply</h2>
                       <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
                    </div>
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Query Title</h6>
                            <p>How do I sign up as a maintenance provider?</p>
                        </div>
                        <div className="w_100">
                            <h6>Query Description</h6>
                            <p>Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance. Whether it's a leaky tap, plumbing issues, electrical work, or routine maintenance, our app makes it easy to request, track, and resolve all maintenance needs.</p>
                        </div>
                        <div className="w_100">
                            <h6>Image</h6>
                            <figure className="passport_img">
                                <img src="/static/images/placeholder.png" alt="Passport" />
                            </figure>
                        </div>
                    </div>
                    <form className="form" action="">
                        <div className="control_group">
                            {status === 'pending' ? (
                                <>
                                    <div className="section_title">
                                        <h2>Add Reply</h2>
                                    </div>
                                    <TextField
                                        placeholder="Enter Reply"
                                        fullWidth
                                        hiddenLabel
                                        multiline
                                        maxRows={5}
                                        minRows={5}
                                    />
                                </>
                            ) : (
                                <div className="view_page gap_p">
                                    <div className="w_100">
                                        <h6>Added Reply</h6>
                                        <p>Thank you for your query. To sign up as a maintenance provider, please visit our registration page and complete the application form. Once submitted, our team will review and approve your profile.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                        {status === 'pending' && (
                            <div className="footer_btn_flex">
                                <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
                                <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </Modal >
    )
}
